import { useTranslate } from "@refinedev/core";

export const useFieldTranslate = (resourceName: string) => {
  const translate = useTranslate();

  return (key: string, defaultVal?: string) => {
    return translate(resourceName + ".fields." + key, defaultVal);
  };
};

export const useActionTranslate = (resourceName: string) => {
  const translate = useTranslate();

  return (key: string, defaultVal?: string) => {
    return translate(resourceName + ".actions." + key, defaultVal);
  };
};

export const useTitleTranslate = (resourceName: string) => {
  const translate = useTranslate();

  return (key: string, options?: any, defaultVal?: string) => {
    return translate(resourceName + ".titles." + key, options, defaultVal);
  };
};

export const useButtonTranslate = () => {
  const translate = useTranslate();

  return (key: string, options?: any, defaultVal?: string) => {
    return translate("buttons." + key, options, defaultVal);
  };
};

export const useFormTranslate = () => {
  const translate = useTranslate();

  return (key: string, options?: any, defaultVal?: string) => {
    return translate("forms." + key, options, defaultVal);
  };
};
